/**
 * Build identity, injected by bin/push.sh as REACT_APP_VERSION in the form
 * "<git tag>+<short sha>", e.g. "1.10.0+692966b". A test deploy off an untagged
 * commit gets the commit count too, e.g. "1.10.0-4+692966b".
 *
 * Deployed builds always have it: push.sh refuses to deploy a dirty tree, and
 * refuses an untagged commit for prod. `npm start` and a hand-run `npm run
 * build` don't set it, so those report "dev".
 */
export const APP_VERSION = process.env.REACT_APP_VERSION ?? "dev";

/**
 * Which deploy channel this bundle was built for: "production", "test" or
 * "development". Comes from the .env.<mode> file bin/push.sh sourced, so it
 * tracks the deploy target -- unlike NODE_ENV, which `react-scripts build`
 * hardcodes to "production" for EVERY build and which would therefore leave a
 * test bundle looking exactly like a production one.
 */
export const DEPLOY_ENV = process.env.REACT_APP_SENTRY_ENV ?? "development";

export const IS_PRODUCTION = DEPLOY_ENV === "production";
